import {useMutation} from '@tanstack/react-query';
import {getLocalStorage} from '@/Utils/CommonUtils';
import ChessRestClient from '@/Api/ChessRestClient';

type WebinarHeldVars = {
  was_held: boolean;
  id: number;
};
export default function useWebinarHeldApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const mutation = useMutation<any, Error, WebinarHeldVars>(
    async (variables: WebinarHeldVars) => {
      const token = await getLocalStorage('access_token');
      const response = await ChessRestClient.post(
        'mark_webinar_held_or_cancelled',
        {
          was_held: variables.was_held,
          id: variables.id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );

      return response;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: error => {
        if (handleOnError) handleOnError(error);
      },
    },
  );

  return {
    ...mutation,
  };
}
